import { gql } from '@apollo/client'

export const GET_HUBRISE_CATALOG = gql`
  query HubriseCatalog {
    hubriseCatalog {
      id
      name
      createdAt
      variants {
        ref
        name
      }
      categories {
        id
        ref
        name
        description
      }
      products {
        id
        ref
        categoryId
        name
        description
        imageIds
        active
        skus {
          id
          ref
          name
          price
          basePriceCents
          active
          pricesByPlatform {
            platformRef
            platformName
            price
            priceCents
            isOverride
          }
          optionListIds
        }
      }
      optionLists {
        id
        ref
        name
        minSelections
        maxSelections
        multipleSelection
        options {
          id
          ref
          name
          price
        }
      }
    }
  }
`

export const PUSH_CATALOG_TO_HUBRISE = gql`
  mutation PushCatalogToHubRise {
    pushCatalogToHubRise {
      success
      catalogId
      productCount
      skuCount
      error
    }
  }
`
